import { useState } from "react";
import { motion } from "framer-motion";

const fmt = (n) => `$${n.toFixed(2)}`;
const WORKERS = ["Ari", "Sam", "Noa", "Kai"];

export const TippingDemo = () => {
  const [mode, setMode] = useState("pooled");
  const [pct, setPct] = useState(18);
  const base = 120;
  const tip = (base * pct) / 100;
  const shares =
    mode === "pooled"
      ? WORKERS.map(() => tip / WORKERS.length)
      : [tip, 0, 0, 0];

  return (
    <div data-testid="tipping-demo" className="rounded-lg border border-border bg-card p-6 sm:p-8">
      <div className="flex items-center justify-between">
        <span className="eyebrow text-muted-foreground">Transparent Tipping</span>
        <div className="inline-flex rounded-md border border-border p-0.5">
          {["individual", "pooled"].map((m) => (
            <button
              key={m}
              type="button"
              data-testid={`tipping-mode-${m}`}
              onClick={() => setMode(m)}
              className={`rounded px-3 py-1 text-xs font-medium capitalize transition-colors ${
                mode === m ? "bg-foreground text-background" : "text-muted-foreground"
              }`}
            >
              {m}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center justify-between text-sm">
          <label className="text-muted-foreground">Tip {pct}%</label>
          <span className="font-mono-ui font-medium text-foreground">{fmt(tip)}</span>
        </div>
        <input
          type="range"
          min="0"
          max="30"
          step="1"
          value={pct}
          data-testid="tipping-percent-slider"
          onChange={(e) => setPct(Number(e.target.value))}
          className="mt-2 w-full accent-foreground"
        />
      </div>

      <div className="mt-6 space-y-2">
        {WORKERS.map((w, i) => (
          <div key={w} className="flex items-center gap-3">
            <span className="w-10 text-xs text-muted-foreground">{w}</span>
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-secondary">
              <motion.div
                className="h-full bg-foreground"
                animate={{ width: `${tip ? (shares[i] / tip) * 100 : 0}%` }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
            <span className="w-14 text-right font-mono-ui text-xs font-medium">
              {fmt(shares[i])}
            </span>
          </div>
        ))}
      </div>

      <p className="mt-5 text-xs leading-relaxed text-muted-foreground">
        {mode === "pooled"
          ? "Pooled tips are split evenly across the team with full payout visibility for every worker."
          : "Individual tips route entirely to the assigned service provider."}
      </p>
    </div>
  );
};
